import Header from "@/components/layout/header/Header";
import SimulationSelector from "@/features/dashboard/components/selector/SimulationSelector";
import UserInfoDisplay from "@/features/dashboard/components/userInfo/UserInfo";
import BackButton from "@/features/dashboard/components/backButton/BackButton";
import { useAuth } from "@/providers/AuthProvider";
import type { appHeaderProps } from "./types.props";


const AppHeader: React.FC<appHeaderProps> = ({
    simulations,
    selectedSimulationId,
    isLoading = false,
    onSimulationChange,
    backButtonPath,
}) => {
    const { user } = useAuth();

    const logoPath = user?.role === "Coordinador de curso"
        ? "/coordinator-dashboard"
        : user?.role === "Estudiante"
            ? "/student-home"
            : "/";

    const centerContent = (simulations && simulations.length > 0 && onSimulationChange && selectedSimulationId) ? (
        <SimulationSelector
            simulations={simulations}
            selectedId={selectedSimulationId}
            onChange={onSimulationChange}
            isLoading={isLoading}
        />
    ) : null;

    return (
        <Header
            variant="dashboard"
            leftContent={backButtonPath ? <BackButton to={backButtonPath} /> : null}
            centerContent={centerContent}
            rightContent={<UserInfoDisplay />}
            logo={!backButtonPath}
            logoLink={logoPath}
        />
    );
};

export default AppHeader;
